import Layout from "../../components/global/Layout";


export default Layout;